<template>
    <Accordion class="mt-6">
        <AccordionTab header="Observações da Etapa">
            <div class="grid mt-2">
                <div class="col-12">
                    <tabela :paginator="false" :mostrarHeader="false" :data="etapas">
                        <template #conteudo>
                            <Column header="Data de envio" :sortable="true">
                                <template #body="slotProps">
                                    {{ formatDate(slotProps.data.dataCadastro) || '' }}
                                </template>
                            </Column>

                            <Column header="Responsável" :sortable="true">
                                <template #body="slotProps">
                                    {{ slotProps.data.nomeResponsavel || '' }}
                                </template>
                            </Column>

                            <Column header="Observação" :sortable="true">
                                <template #body="slotProps">
                                    {{ formatarObservacao(slotProps.data) }}
                                </template>
                            </Column>
                        </template>
                    </tabela>
                </div>
            </div>
        </AccordionTab>
    </Accordion>
</template>

<script>
export default {
    props: {
        etapas: {
            type: Array,
            required: true,
        },
    },
    methods: {
        formatDate(dateString) {
            return this.$moment(dateString).format('DD/MM/YYYY HH:mm');
        },
        formatarObservacao(etapa) {
            if (etapa.observacao) {
                return etapa.observacao;
            }
            return etapa.motivoReprovacao ? etapa.motivoReprovacao : 'Sem observação';
        },
    },
};
</script>

<style scoped>
.mt-4 {
    margin-top: 2rem;
}

.grid {
    margin-top: 2rem;
}
</style>
